import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { ROUTES } from './consts';
const LessonCompletionPage = lazy(() => import('@/pages/LessonCompletionPage/LessonCompletionPage'));
const ErrorPage = lazy(() => import('@/pages/ErrorPage/ErrorPage'));
const AwardTokensPage = lazy(() => import('@/pages/AwardTokensPage'));
const router = createBrowserRouter([
    {
        path: '/',
        element: _jsx(LessonCompletionPage, {}),
        errorElement: _jsx(ErrorPage, {}),
    },
    {
        path: ROUTES.lessonCompletion,
        element: _jsx(LessonCompletionPage, {}),
        errorElement: _jsx(ErrorPage, {}),
    },
    {
        path: ROUTES.achievementTokens,
        element: _jsx(AwardTokensPage, {}),
        errorElement: _jsx(ErrorPage, {}),
    },
]);
export default router;
